// Export interfaces
export * from './interfaces/auth';
export * from './interfaces/theme';
export * from './interfaces/storage';
export * from './interfaces/navigation';
export * from './interfaces/deviceInfo';
export * from './interfaces/platform';
export * from './interfaces/contact';

// Export specific types from interfaces
export type { ContactInquiryBase, ContactInquiry, ContactInquiryStatus } from './interfaces/contact';

// Export types (remove auth export)
export * from './types/base';

// Export schemas
export {
  loginSchema,
  signUpSchema,
} from './schemas/auth';
export {
  contactInquirySchema,
  contactInquiryResponseSchema,
} from './schemas/contact';

// Export services
export { AuthService } from './services/authService';
export { ApiClient } from './services/apiClient';
export { ContactService } from './services/contactService';

// Export errors
export { AuthError } from './errors/AuthError';

// Export hooks
export { useAuth } from './hooks/useAuth';
export { useContactService } from './hooks/useContactService';

// Export stores
export { useAuthStore } from './stores/authStore';
export { useThemeStore } from './stores/themeStore';

// Export providers
export * from './providers/AuthProvider';

// Export Supabase interfaces and types
export type { SupabaseAdapter, SupabaseConfig, SupabaseError } from './interfaces/supabase';

// Export adapter registration functions
export {
  registerStorageAdapter,
  registerNavigationAdapter,
  registerDeviceInfoAdapter,
  getStorageAdapter,
  getNavigationAdapter,
  getDeviceInfoAdapter,
} from './adapters'; 